<template>
  <div style="position: relative">
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
      min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-img style="
                                  width: 20px;
                                  height: 25px;
                                  position: absolute;
                                  left: 12px;
                                  top: 20px;
                                " id="logo" contain src="@/assets/calendarGray.svg" />
        <i aria-hidden="true" @click="handleDelete" style="position: absolute; left: 33px; top: 21px"
          class="v-icon notranslate mdi mdi-close theme--light"></i>
        <v-text-field v-model="date" :label="label" prepend-icon="mdi-calendar" outlined dense v-bind="attrs" v-on="on"
          readonly class="remove-padding-v-slot"></v-text-field>
      </template>
      <!-- <v-date-picker v-model="date" :active-picker.sync="activePicker"
                       :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                       min="1950-01-01" @change="save"></v-date-picker> -->

      <v-date-picker v-model="date" :active-picker.sync="activePicker"
        :max="new Date(new Date().getFullYear() + 3, 11, 31).toISOString().substr(0, 10)" min="1950-01-01"
        @change="save"></v-date-picker>
    </v-menu>
  </div>
</template>


<script>
export default {
  name: "pickerInput",
  props: ["name", "label"],

  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },
  methods: {
    handleDelete() {
      this.date = null
      this.$emit('dateValue', this.date)
    },
    save(date) {
      this.$refs.menu.save(date)
      this.$emit('dateValue', date)
    },
  },


}
</script>
<style>
.remove-padding-v-slot input {
  padding-right: 7px;
}
</style>
